<template functional>
  <hr :class="[data.staticClass, data.class, $style.divider]" />
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'AtomDivider',
});
</script>

<style lang="scss" module>
.divider {
  border: 0;
  border-top: $BORDER;
}
</style>
